import React from "react";

const assetOption = ({ option }) => (
  <div className="fba-center" style={{ width: "100%" }}>
    <div style={{ width: "calc(100% - 65px)" }}>
      <p className="mb-xsmall">
        <strong>{option.label}</strong>
      </p>
      <p className="t-xsmall mb-xsmall">
        <span className="f-mono">
          Uploaded {option.created_at} by {option.uploaded_by_name}
        </span>
      </p>
      {option.published ? (
        <div className="label label--ghost">Published</div>
      ) : (
        <div>
          <p className="t-xsmall mb-xsmall">
            <span className="f-mono">{option.publication_summary}</span>
          </p>
          <div className="label label--warning">
            {option.publication_status}
          </div>
        </div>
      )}
    </div>
    <div style={{ width: "50px", marginLeft: "15px" }}>
      {option.image_url ? (
        <img alt="" style={{ maxWidth: "100%" }} src={option.image_url} />
      ) : (
        ""
      )}
    </div>
  </div>
);

export default assetOption;
